import {
  BackArrowIcon,
  ExitIcon,
  ProfileIcon,
  ShareIcon
} from "../../Assets/assets";
import "./Header.css";

export default function Header(props) {
  return (
    <div className="height-64px background-color-primary inherit-parent-width display-flex flex-align-items-center padding-large">
      <div className="flex-justify-content-space-between inherit-parent-width">
        <div className="display-flex flex-align-items-center flex-justify-content-center">
          {props.backOnClick && (
            <div
              data-cy="back-arrow-button"
              className="display-flex flex-align-items-center flex-justify-content-center padding-right-default"
              onClick={props.backOnClick}
            >
              <BackArrowIcon color="#FFFFFF" />
            </div>
          )}
          <div className="font-size-default font-color-white font-family-RHD-medium">
            {props.title}
          </div>
        </div>

        {props.profileOnClick && (
          <div
            data-cy="profile-icon"
            style={{ width: "30px", height: "40px" }}
            onClick={props.profileOnClick}
          >
            <ProfileIcon height="40px" width="30px" color="white" />
          </div>
        )}

        {props.logoutOnClick && (
          <div data-cy="logout-button" onClick={props.logoutOnClick}>
            <ExitIcon color="#FFFFFF" />
          </div>
        )}

        {/* {!props.profileOnClick && !props.logoutOnClick && (
          <img
            src={chennaiCorporationLogo}
            alt="chennai-corporation-logo"
            width="30px"
          />
        )} */}
        {typeof props.shareOnclick === "function" ? (
          <div
            data-cy="share-icon"
            onClick={props.shareOnclick}
            style={{ width: "18px", height: "18px" }}
          >
            <ShareIcon height="18px" width="18px" color="#FFFFFF" />
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
